const enHostRating = {
  hostRating: {
    label: {
      title: 'Host Rating',
      comment: 'Comment',
      rate: 'Rate Host',
    },
    hint: {
      rating: 'Rating with {rating} stars',
      about: 'Evaluate the service provided by the host who performed this service.',
    },
    action: {
      sendRating: 'Send Rating',
    },
    messages: {
      success: 'Thank you for your rating.',
      appointmentNotFound: 'Appointment not found',
    }
  },
}

export default enHostRating
